import styled, { css, keyframes } from 'styled-components';
import {
  FlexCenterAligned,
  FlexCenteredColumn
} from '../../../../styled/common';
import { Breakpoints } from '../../../../styled/constants';
import { getSafeAreaValue } from '../../../../styled/theme/helpers/getSafeAreaValue';

export const ShowAllBtn = styled(FlexCenterAligned)`
  border-radius: 7px;
  background: linear-gradient(
    90deg,
    #ccdfe3 0%,
    #d7e7eb 17.5%,
    #e6f8f2 40.5%,
    rgba(231, 242, 238, 0.92) 61%,
    rgba(225, 235, 232, 0.76) 100%
  );
  color: ${({ theme: { colors } }) => colors.text.primary};
  text-align: center;
  width: 89px;
  height: 25px;
  padding: 0;
  margin-left: auto;
  cursor: pointer;
`;

export const CurrentItemTitleWrapper = styled(FlexCenteredColumn)`
  width: 100%;
  padding-top: ${({ theme }) => getSafeAreaValue(theme, 'top', 0, 10)};
  position: sticky;
  top: 0;

  ${({ theme }) =>
    theme.isWebView &&
    css`
      align-items: flex-end;
    `};

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    a {
      pointer-events: none;
      color: inherit;
      text-decoration: none;
      cursor: default;
    }
  }
`;

export const PhotosGridWrapper = styled.div<{ $isLessThan3: boolean }>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 100px;
  gap: 11px;
  grid-auto-flow: dense;
  overflow-y: auto;
  height: 100%;
  padding-bottom: ${({ theme }) => getSafeAreaValue(theme, 'bottom', 20)};

  &::-webkit-scrollbar {
    display: none;
  }

  ${({ $isLessThan3 }) =>
    $isLessThan3 &&
    css`
      grid-template-columns: 1fr;
    `};

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0 40px 30px;
    gap: 20px;
    grid-auto-rows: auto;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    grid-template-columns: repeat(3, 1fr);

    ${({ $isLessThan3 }) =>
      $isLessThan3 &&
      css`
        grid-template-columns: repeat(3, 1fr);
      `};
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    padding-right: 0;
    padding-left: 0;
  }
`;

export const modalBackdropStyles = css`
  background-color: transparent;
  transition: all 0.3s ease;

  @media (min-width: ${Breakpoints.tablet}px) {
    height: 100vh;
    max-height: 100vh;
    width: 100vw;
    max-width: 100vw;
    align-self: center;
  }
`;

const showFromLeft = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
`;

const hideToLeft = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
`;

export const getModalStyles = (isOpen: boolean) => css`
  ${modalBackdropStyles};
  border-radius: 0;
  background-color: ${({ theme }) => theme.colors.background.primary};
  z-index: 70002;

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    animation: ${isOpen ? showFromLeft : hideToLeft} 0.4s forwards ease-in-out;
  }
  @media (min-width: ${Breakpoints.desktop}px) {
    padding: 0 max(40px, calc((100% - 1280px) / 2));
    border-radius: 0;
  }
`;
